import { memo, useEffect, useState } from 'react';
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';

import './css/Popups.css';
import { MdOutlineClose } from "react-icons/md";

export default memo(function Popup({children, style, index, className}) {

    const navigate = useNavigate();

    function closePopup(e) {
        const cls = e?.target?.getAttribute("class");
        if (cls == "popupBox") {
            navigate(-1);
        }
    }

    if (!index) {
        index = 17;
    }

    useEffect(() => {

        const elem = document.getElementsByClassName("popupBox")[0];  
        elem.addEventListener("click", closePopup);

        return () => {
            elem.removeEventListener("click", closePopup);
        };

    }, []);


    return (
        <div className={`popupBox ${className}`} style={{zIndex:index}}>
            <div className='popup' style={style}>
                <a className='closePop' onClick={() => navigate(-1)}><MdOutlineClose size={20}/></a>
                {children}
            </div>
        </div>
    );
    
})